"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DomainClient = void 0;
const axios_1 = require("axios");
const bad_request_exception_1 = require("./exceptions/bad-request-exception");
const internal_server_exception_1 = require("./exceptions/internal-server-exception");
const not_found_exception_1 = require("./exceptions/not-found-exception");
class DomainClient {
    constructor(baseUrl, apiKey, model, version, isPublic, seed) {
        this.baseUrl = baseUrl;
        this.apiKey = apiKey;
        this.model = model;
        this.version = version;
        this.isPublic = isPublic;
        this.seed = seed;
    }
    async doRequest(ids) {
        const url = this.buildUrl(ids);
        const config = { baseURL: this.baseUrl };
        if (this.apiKey !== undefined) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            config["headers"] = { 'x-api-key': this.apiKey };
        }
        const axiosResponse = await axios_1.default.get(url, config);
        const response = axiosResponse.data;
        this.handleErrors(response);
        const models = [];
        for (const id of ids) {
            const modelData = response.data[id];
            if (!modelData) {
                continue;
            }
            models.push(modelData);
        }
        return models;
    }
    handleErrors(response) {
        if (!response.status) {
            throw new internal_server_exception_1.InternalServerException(response.message);
        }
        if (response.status === 400) {
            throw new bad_request_exception_1.BadRequestException(response.message);
        }
        if (response.status === 404) {
            throw new not_found_exception_1.NotFoundException(response.message);
        }
    }
    buildUrl(ids) {
        const publicPrefix = this.shouldAddPublicPrefix() ? 'public/' : '';
        let query = `${publicPrefix}${this.model}/${this.version}/?seed=${this.seed}`;
        for (const id of ids) {
            query += `&id=${id}`;
        }
        return query;
    }
    shouldAddPublicPrefix() {
        return this.isPublic && this.apiKey === undefined;
    }
}
exports.DomainClient = DomainClient;
//# sourceMappingURL=domain-client.js.map